var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showInfo)?_c('div',[_c('base-alert',{attrs:{"type":"secondary"}},[_c('span',{staticClass:"alert-inner--icon"},[_c('i',{staticClass:"ni ni-air-baloon"})]),_c('span',{staticClass:"alert-inner--text"},[_vm._v(_vm._s(_vm.$t('info')))])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }